import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import Sensors from '@/util/Sensors'
import '@/publicResource/flexible/index.js'
import { Toast, Progress, Slider } from 'vant'
import VConsole from 'vconsole'
import wx from 'weixin-js-sdk'
import { isInWxMP } from "@/util";
if (isInWxMP()) {
  window.wx = wx
}
// axios使用了promise，默认babel不会兼容node_module依赖的库，所以增加promise兼容
require('es6-promise').polyfill()
Vue.use(Toast).use(Progress).use(Slider)
if (process.env.VUE_APP_ENV_MICRO !== 'production') {
  new VConsole()
}
Vue.prototype.$littleToast = (msg, onClose) => {
  return Toast({
    message: msg,
    duration: 2000,
    forbidClick: true,
    onClose: () => onClose && onClose()
  })
}

Vue.prototype.$loading = (message, duration = 0) => {
  return Toast.loading({
    message,
    duration,
    forbidClick: true
  })
}
// 初始化埋点
const channelFromQuery = window.location.href.match(/[?&]f=([^&/#]*)/)
const channelFrom = channelFromQuery && channelFromQuery[1]

Vue.prototype.$sensors = new Sensors({ channel: channelFrom || '0' })
// 重制埋点匿名ID
const distinctIDQuery = window.location.href.match(/[?&]distinctID=([^&/#]*)/)
const distinctID = distinctIDQuery && distinctIDQuery[1]
Boolean(distinctID) && Vue.prototype.$sensors.identify(distinctID)

// 全局路由后置守卫
router.afterEach((to, from) => {
  // 承接页浏览事件埋点
  if (to.name !== 'themeA') {
    const title = to.meta?.title
    Vue.prototype.$sensors.track('onPageView', {
      page_souce: document.referrer,
      page_name: `产品承接页-${title}`,
      page_id: 0,
      page_url: window.location.href,
      page_content: ''
    })
  }
  // 神策单页路由触发pv统计事件
  Vue.prototype.$sensors.autoTrackSinglePage()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
